import { TActions } from '../../../AppModulesWrapper';

import { IElementsVisibilityState } from '../../types/reducers/elementsVisibility';
import { SET_ELEMENTS_VISIBILITY_PRESET } from '../../actions/elementsVisibility';

import { defaultState } from './defaultState';
import { RESET_STATE } from '../../actions/resetState';

export const elementsVisibility = (
  state: IElementsVisibilityState = defaultState,
  action: TActions,
): IElementsVisibilityState => {
  switch (action.type) {
    case SET_ELEMENTS_VISIBILITY_PRESET:
      return { ...action.payload };

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
};
